import { registerPropertyManagerSection } from '@/core';
import RevolvePropertySection from '@/components/editor/property-manager/revolve/RevolvePropertySection.vue';

registerPropertyManagerSection({
  id: 'revolve-boss',
  title: '旋转凸台/基体',
  order: 31,
  component: RevolvePropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.revolveState?.canSubmit === false,
  isApplicable: (context) => {
    if (context.activeCommand === 'revolve-boss') {
      return true;
    }
    return Boolean(context.revolveActive);
  },
  onConfirm: (context) => {
    context.onConfirm?.();
  },
  onCancel: (context) => {
    context.cancelRevolve?.();
  },
});
